// @flow
import * as React from 'react'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import './styles.scss'

function ArticleLink({
  publisherDomain,
  articleId,
  title,
  lead
}: {
  publisherDomain: string,
  articleId: string,
  title: string,
  lead: string
}) {
  return (
    <a
      href={`https://www.${publisherDomain}/${articleId}`}
      target='_parent'
      className='item'
    >
      <i className='external icon top aligned' />
      <div className='content'>
        <div className='header'>{title}</div>
        {lead}
      </div>
    </a>
  )
}

export function ArticleList() {
  const publisherDomain = parseHostname().publicationDomain

  return (
    <aside
      className='ui segment article-list'
      style={{ backgroundColor: '#fff' }}
    >
      <h4 className='ui infographic tiny header'>
        Articles en lien avec «L'argent et vous»:
      </h4>
      <div className='ui icon very infographic list'>
        <ArticleLink
          publisherDomain={publisherDomain}
          articleId={
            publisherDomain === 'tdg.ch' ? '626632723403' : '516256098474'
          }
          lead={
            publisherDomain === 'tdg.ch'
              ? 'L’économie genevoise à l’épreuve du virus'
              : 'L’économie vaudoise tient le choc pendant la crise'
          }
        />
        <ArticleLink
          publisherDomain={publisherDomain}
          articleId='490177596929'
          lead='Des «risques de dégradation» de l’horizon économique'
        />
      </div>
    </aside>
  )
}
